import { render, staticRenderFns } from "./DeliverablesInProjectList.vue?vue&type=template&id=7e35cd3e&"
import script from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"
export * from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"
import style0 from "./DeliverablesInProjectList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e35cd3e')) {
      api.createRecord('7e35cd3e', component.options)
    } else {
      api.reload('7e35cd3e', component.options)
    }
    module.hot.accept("./DeliverablesInProjectList.vue?vue&type=template&id=7e35cd3e&", function () {
      api.rerender('7e35cd3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverablesInProjectList.vue"
export default component.exports